{
    "BroadworksProvisioningHeader": "Provisioning del Service Pack Broadworks",
    "BroadworksProvisioningTableHeaderEnabled": "Abilitato",
    "BroadworksProvisioningTableHeaderItem": "Articolo",
    "BroadworksProvisioningTableHeaderServicePack": "Pacchetto di servizio",
    "BroadworksProvisioningTableHeaderTelephonyServers": "Server di telefonia",
    "BroadworksProvisioningAddEntry": "Aggiungi voce...",
    "BroadworksProvisioningItemExtension": "Estensione",
    "BroadworksProvisioningItemHospitality": "Ospitalità",
    "BroadworksProvisioningItemAcdAgent": "Agente ACD",
    "BroadworksProvisioningButtonDiscardChanges": "Modifiche di scarto",
    "BroadworksProvisioningButtonSave": "Risparmiare",
    "BroadworksProvisioningButtonActions": "Azioni",
    "BroadworksProvisioningButtonDelete": "Cancellare",
    "BroadworksProvisioningButtonEdit": "Modifica",
    "BroadworksProvisioningValueIsRequired": "Il valore è richiesto.",
    "NAME": "Provisioning",
    "BroadworksProvisioningTableHeaderSendWelcomeEmail": "Inviare un'e-mail di benvenuto",
    "BroadworksProvisioningItemEssentials": "Elementi essenziali",
    "BroadworksProvisioningItemProfessional": "Professionale",
    "BroadworksProvisioningItemCallCentreAgent": "Agente di call center",
    "BroadworksProvisioningItemEnterprise": "Impresa",
    "BroadworksProvisioningItemCallCentreSupervisor": "Supervisore del call center",
    "BroadworksProvisioningItem1000": "Akixi 1000",
    "BroadworksProvisioningItem2000": "Akixi 2000"
}